import { createSelector } from '@reduxjs/toolkit'

import { RootState } from 'src/v2/store/store'

const userSession = (state: RootState) => state.user.userSession

export const selectCurrentOrganization = createSelector(
  [userSession],
  (userSession) => userSession.currentOrganization,
)

export const selectOrganizations = createSelector(
  [userSession],
  (userSession) => userSession.organizations,
)

export const selectPolicies = createSelector(
  [userSession],
  (userSession) => userSession.policies,
)

export const selectUser = createSelector(
  [userSession],
  (userSession) => userSession.user,
)

export const selectUserMembership = createSelector(
  [userSession],
  (userSession) => userSession.membership,
)
